module.exports = __webpack_public_path__ + "fonts/iconfont.3070ff73.woff";